/**
 * Cloudflare Web Analytics (SP3, cue-forge-kxt.5): a cookieless, privacy-first
 * pageview beacon — no cookies, no cross-site tracking, no personal data, and it
 * never sees the user's subtitle files. The beacon token comes from the
 * Cloudflare dashboard and is injected at build time via `VITE_CF_BEACON_TOKEN`.
 * When unset (local dev, CI, tests), no external script is emitted, so the
 * offline/privacy guarantees and the e2e suite are unaffected.
 *
 * On Cloudflare Pages you can alternatively enable Web Analytics from the
 * dashboard (automatic edge injection) and skip the token entirely.
 */
/**
 * First-party analytics ingest endpoint (cue-forge-do7). The full URL of the
 * deployed ingest Worker, supplied at build time via `VITE_ANALYTICS_URL`. While
 * unset (dev, CI, tests, e2e), the client analytics module is wholly inert — no
 * queueing, no storage, no network — so the offline/privacy guarantees hold. An
 * empty string normalizes to undefined so it is treated the same as unset.
 */
// `import.meta.env` is undefined when this module is evaluated by Node rather
// than Vite — e.g. `vite.config.ts` imports `cfBeaconTag` from this same file,
// so loading the config transitively evaluates this top-level const. Optional
// chaining keeps that path (and any other non-Vite import) from throwing; in the
// real app build Vite statically replaces `import.meta.env.VITE_ANALYTICS_URL`.
export const ANALYTICS_URL: string | undefined =
  (import.meta.env?.VITE_ANALYTICS_URL as string | undefined) || undefined;

export function cfBeaconTag(token?: string): string {
  const trimmed = token?.trim();
  if (!trimmed) return '';
  const beacon = JSON.stringify({ token: trimmed });
  return `<script defer src="https://static.cloudflareinsights.com/beacon.min.js" data-cf-beacon='${beacon}'></script>`;
}
